import React from 'react';
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import DivTable from "../../components/divTable";
import {Button} from "react-bootstrap";
import Security from "../../components/security";

class SignaturePAI extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            DemandeDecretInclusifID: null,
            PAI: null,
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let {body} = await Get(`/v1/extranet/student/${screens.DecretInclusif}`);
        let decret = body;

        ({body} = await Get(`/v1/extranet/student/${screens.SignaturePAI}`));

        this.setState({
            DemandeDecretInclusifID: decret.DemandeDecretInclusifID,
            PAI: body
        });
    }

    async save() {
        await Post(`/v1/extranet/student/${screens.SignaturePAI}`, {
            DemandeDecretInclusifID: this.state.DemandeDecretInclusifID
        }, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

        let {body} = await Get(`/v1/extranet/student/${screens.SignaturePAI}`);

        if (body === null) {
            Security.denyPage(screens.SignaturePAI);
        }

        this.props.history.push(process.env.APP_ROOT + 'desktop');
    }

    renderPAI() {
        return (
            <>
                <p>Le PAI a été rédigé conformément au décret du 30 janvier 2014 relatif à l’enseignement inclusif pour les étudiants en situation de handicap et dans le respect du règlement de la Haute Ecole ICHEC-ECAM-ISFSC.</p>
                <p>En signant ce PAI, vous vous engagez à vous présenter à l’heure aux examens pour faire valoir le droit d’obtenir du temps supplémentaire.</p>
                <p className={"mb-5"}>Vérifiez une dernière fois votre PAI et si tout est en ordre, cliquez sur « Signer
                    mon PAI en ligne ».
                    <br/>Au cas où vous constateriez une anomalie, ne cliquez pas et prenez contact avec la personne gestionnaire de votre PAI.</p>
                <DivTable columns={{
                    "Code": "UniteEnseignementCode",
                    "Libellé": "UniteEnseignementLibelle",
                    "Aménagements": "Amenagements",
                }}
                          array={this.state.PAI}/>
                <br/>
                <br/>
                <br/>
                <Button block size={"lg"} variant={"success"}
                        onClick={this.save.bind(this)}>Signer mon PAI en ligne</Button>
            </>
        );
    }

    render() {
        return (
            <section>
                {this.state.PAI && this.renderPAI()}
            </section>
        );
    }
}

export default withRouter(SignaturePAI);